import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AvatarFrame from '../../common/AvatarFrame/AvatarFrame';
import { getProfilePhotoSrc, PLACEHOLDER_DATA_URI } from '../../../utils/profilePhoto';

/**
 * Account Settings > Privacy: everyone you've blocked, with Unblock.
 * A block stops messages and trade offers both ways and hides you from
 * each other's trader lists.
 */
function BlockedTraders() {
    const [list, setList] = useState(null);
    const [busy, setBusy] = useState(null);

    const load = () => fetch('/api/blocks', { credentials: 'include' })
        .then(r => (r.ok ? r.json() : { blocked: [] }))
        .then(d => setList(d.blocked || []))
        .catch(() => setList([]));
    useEffect(() => { load(); }, []);

    const unblock = async (id) => {
        setBusy(id);
        try {
            await fetch(`/api/blocks/${id}`, { method: 'DELETE', credentials: 'include' });
            setList(l => l.filter(u => u.id !== id));
        } finally {
            setBusy(null);
        }
    };

    return (
        <div className="settings-section">
            <h2 className="settings-title">Blocked traders</h2>
            <p className="blocked-hint">
                Blocked traders can't message you or send you trade offers, and you won't see each other in trader lists.
            </p>
            {list === null ? (
                <p className="blocked-hint">Loading&hellip;</p>
            ) : list.length === 0 ? (
                <p className="blocked-hint">You haven't blocked anyone.</p>
            ) : (
                <ul className="blocked-list">
                    {list.map(u => (
                        <li key={u.id}>
                            <AvatarFrame user={u}>
                                <img
                                    src={getProfilePhotoSrc(u)}
                                    alt=""
                                    onError={e => { e.target.onerror = null; e.target.src = PLACEHOLDER_DATA_URI; }}
                                />
                            </AvatarFrame>
                            <Link to={`/profile/${u.id}`} className="blocked-name">{u.username}</Link>
                            <button className="blocked-unblock" disabled={busy === u.id} onClick={() => unblock(u.id)}>
                                Unblock
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default BlockedTraders;
